module.exports = __webpack_public_path__ + "img/menu_11.90ef2741.png";